import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import QRCode from "react-qr-code";
import Container from "@mui/material/Container";
import dayjs from "dayjs";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";

import { isMobile } from "react-device-detect";

import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import HeaderText from "../../components/HeaderText";
import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";

import {
  getActivityDate,
  ACTIVITY_QR_KEY,
  encryptActivitySignup,
} from "../../services/ActivityService";
import { getQrBaseUrl } from "../../services/QrService";
import {StripedTableCell, StripedTableHeadCell, StripedTableRow} from "../../components/StripedTable";

const ActivitySignupQr = () => {
  const { eid } = useParams();
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [showProgress, setShowProgress] = useState(false);
  const [_searchPerformed, setSearchPerformed] = useState(false);
  const [_qrUrl, setQrUrl] = useState("");

  const [_activityDate, setActivityDate] = useState({
    eid: "",
    name: "",
    date: "",
    period: "",
    periodName: "",
    last_name: "",
    first_name: "",
    locationName: "",
  });

  useEffect(() => {
    initContent();
  }, []);

  const initContent = () => {
    setShowProgress(true);

    const promises = [getActivityDate(_school, _jwt, eid), getQrBaseUrl(_school, _jwt)];

    Promise.all(promises).then((results) => {
      let result = results[0];

      setActivityDate(result.data);
      const encrypted = encryptActivitySignup(ACTIVITY_QR_KEY, eid);
      setSearchPerformed(true);

      const baseUrl = results[1];
      setQrUrl(baseUrl + `/student/ad/signup/${encrypted}`)
      setShowProgress(false);
    });
  };


  const getQrCode = () => {
    if (isMobile) {
      return (
        <QRCode
          size={256}
          style={{ height: "auto", maxWidth: "80%", width: "80%" }}
          value={_qrUrl}
          viewBox={`0 0 256 256`}
        />
      );
    } else {
      return <QRCode size={512} value={_qrUrl} />;
    }
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Signup QR Code" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Box sx={{ display: _searchPerformed ? "" : "none" }}>
          <HeaderText text={_activityDate.name} />
          <Table size="small">
            <TableBody>
              <StripedTableRow>
                <StripedTableHeadCell>Date</StripedTableHeadCell>
                <StripedTableCell>
                  {dayjs(_activityDate.date).format("MM/DD/YYYY")}
                </StripedTableCell>
                <StripedTableHeadCell>Period</StripedTableHeadCell>
                <StripedTableCell>{_activityDate.periodName}</StripedTableCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>Location Name</StripedTableHeadCell>
                <StripedTableCell>{_activityDate.locationName}</StripedTableCell>
                <StripedTableHeadCell>Main Proctor</StripedTableHeadCell>
                <StripedTableCell>
                  {_activityDate.first_name} {_activityDate.last_name}
                </StripedTableCell>
              </StripedTableRow>
            </TableBody>
          </Table>
          <p style={{ textAlign: "center" }}>{getQrCode()}</p>
          <p>
            <a href={_qrUrl}>Link</a>
          </p>
        </Box>
      </Container>
    </>
  );
};

export default ActivitySignupQr;
